"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filter = exports.message = exports.accessor = exports.selectOnly = exports.readOnly = exports.disabled = exports.elementType = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var filter_1 = __importDefault(require("./filter"));
var filterTypes = Object.keys(filter_1.default).filter(function (i) {
  return i !== 'filter';
});
function getInteractionPropType(key) {
  var types = [prop_types_1.default.bool, prop_types_1.default.oneOf([key])];
  var propType = prop_types_1.default.oneOfType(types);
  propType['acceptsArray'] = prop_types_1.default.oneOfType(types.concat(prop_types_1.default.array));
  return propType;
}
function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName) {
    var rest = [];
    for (var _i = 4; _i < arguments.length; _i++) {
      rest[_i - 4] = arguments[_i];
    }
    componentName = componentName || '<<anonymous>>';
    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required prop `' + propName + '` was not specified in  `' + componentName + '`.');
      }
    } else {
      return validate.apply(void 0, __spreadArrays([props, propName, componentName], rest));
    }
  }
  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
}
exports.elementType = createChainableTypeChecker(function (props, propName, componentName) {
  if (typeof props[propName] !== 'function') {
    if (react_1.default.isValidElement(props[propName])) {
      return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' + ' Expected an Element `type`, not an actual Element');
    }
    if (typeof props[propName] !== 'string') {
      return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' + ' Expected an Element `type` such as a tag name or return value of React.createClass(...)');
    }
  }
  return null;
});
exports.disabled = getInteractionPropType('disabled');
exports.readOnly = getInteractionPropType('readOnly');
exports.selectOnly = getInteractionPropType('readOnly');
exports.accessor = prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.func]);
exports.message = prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.string]);
exports.filter = prop_types_1.default.oneOfType([prop_types_1.default.func, prop_types_1.default.bool, prop_types_1.default.oneOf(filterTypes)]);
exports.default = {
  elementType: exports.elementType,
  disabled: exports.disabled,
  readOnly: exports.readOnly,
  selectOnly: exports.selectOnly,
  accessor: exports.accessor,
  message: exports.message,
  filter: exports.filter
};